import { Empty, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import Icon from "../../Icon"
import Images from "../../Images"

import "./styles.less"

const { Title, Text } = Typography

const data = {
  alerts: {
    title: "No alerts found yet",
    text: "Currently, your account has no alerts",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  credits: {
    title: "No credits requests found yet",
    text: "Currently, your account has no credits requests",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  // Empty /recover/all before Recover is activated: the Configure wizard is the way in, so the
  // caller adds the CTA buttons as children.
  activate_recover: {
    title: "Activate Recover",
    text: "Fight chargebacks automatically. We scan your payment gateways, build evidence PDFs from your business profile, and submit them before the deadline.",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  search: {
    title: "No results were found for your search",
    text: "Let's refine your search or try something different.",
    img: <Icon type="inbox_empty" style={{ fontSize: 32 }} />,
    imgHeight: 32
  },
  alerts_admin: {
    title: "No alerts found",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  business_accounts_admin: {
    title: "No business accounts found",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  users_admin: {
    title: "No users found",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  requests_enrollments_admin: {
    title: "No requests for new enrollments found",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  requests_receipts_admin: {
    title: "No receipt requests found",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  requests_billing_descriptors_admin: {
    title: "No requests for adding new billing descriptors found",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  requests_auto_refunds_admin: {
    title: "No requests for auto-refund adjustments found",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  requests_integrations_admin: {
    title: "No requests for adding new integrations found",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  requests_credits_admin: {
    title: "No requests for new credits found",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  requests_verifi_inform_admin: {
    title: "No requests for verifi inform found",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  // Recover Analytics: nothing to aggregate at all, versus nothing inside the selected
  // calendar window. The second one is recoverable by widening the range, so it says so.
  no_disputes: {
    title: "No disputes yet",
    text: "When new chargebacks land in your connected payment processors, they'll appear here.",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  no_disputes_in_range: {
    title: "No disputes in this period",
    text: "Try widening the date range to see results.",
    img: <Icon type="no_data_available" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  // Win rate has no honest value until an issuer rules on something: 0% reads as a failure
  // that has not happened yet.
  no_win_rate_yet: {
    title: "No decisions yet",
    text: "Win rate appears here once an issuer rules on a dispute. Issuers can take up to 90 days to decide after a response is sent.",
    disabled: true,
    img: <Icon type="no_data_available" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  no_data_available: {
    title: "No data available",
    disabled: true,
    img: <Icon type="no_data_available" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  no_lookups_in_range: {
    title: "Nothing in this range",
    text: "No bank inquiry arrived inside the selected window. Widen the calendar above to see more.",
    img: <Icon type="no_data_available" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  digital_receipt: {
    title: "Reduce disputes with Digital Receipt",
    text: "Show cardholders clear purchase details so they recognize legitimate charges and file fewer disputes.",
    img: <Icon type="receipt_bill" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  no_data_available_webhooks_endpoints: {
    title: "No endpoints available",
    text: "Your webhook endpoints will appear here. Create your first endpoint to start receiving events automatically.",
    img: <img src={Images.no_data_available_webhooks} alt="" width={325} height={124} />,
    imgDark: <img src={Images.no_data_available_webhooks_dark} alt="" width={325} height={124} />,
    imgHeight: 124
  },
  no_data_available_webhooks_events: {
    title: "No events available",
    text: "No events have been received yet. Webhook events will appear here once endpoint starts receiving requests from the API.",
    img: <img src={Images.no_data_available_webhooks} alt="" width={325} height={124} />,
    imgDark: <img src={Images.no_data_available_webhooks_dark} alt="" width={325} height={124} />,
    imgHeight: 124
  }
}
const EmptyComponent = ({ type, children, style, ...props }) => {
  const { t } = useTranslation()
  const theme = useSelector((state) => state.nav.theme)
  const { img, imgDark } = data[type] || {}
  return (
    <Empty
      className={`custom-empty custom-empty_${type}`}
      image={theme === "dark" ? imgDark || img : img}
      imageStyle={{ height: data[type]?.imgHeight || 0 }}
      style={style}
      description={
        <>
          <Title level={5} disabled={data[type]?.disabled}>
            {t(data[type]?.title)}
          </Title>
          <Text type={"secondary"}>{t(data[type]?.text)}</Text>
        </>
      }
    >
      {children}
    </Empty>
  )
}
export default EmptyComponent
